/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { iotDevicesDuocolor } from "../assets/iot-devices-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconIotDevicesDuocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={iotDevicesDuocolor.svg} />
);

IllustrativeIconIotDevicesDuocolor.displayName = "IllustrativeIconIotDevicesDuocolor";
